module.exports = __webpack_public_path__ + "static/img/redyong_07@2x.d53b28e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/party/redyong_07@2x.png
// module id = T78P
// module chunks = 0